import React, { useState } from "react";
import {
  Grid,
  Col,
  Row,
  FormGroup,
  InputGroup,
  FormControl,
  Button,
  Glyphicon,
  Collapse,
} from "react-bootstrap";
import styled from "styled-components";
import { useDispatch } from "react-redux";

import LoadingComponent from "components/LoadingComponent";
import EntitlementDetail from "components/EntitlementDetail";
import Loader from "components/Loader";
import PanelTitle from "components/PanelTitle";
import { Panel, PanelHeader } from "../../Panel";

import { VoucherStatus } from "constant";

import isEmpty from "lodash/isEmpty";
import moment from "moment";
import toastr from "toastr";

import { getVoucher, validateInvalidateVoucher } from "./action";

const SearchButton = styled(Button)`
  border: 1px solid #265a88 !important;
  padding: 10px 15px;
  border-bottom-right-radius: 20px !important;
  border-top-right-radius: 20px !important;
`;
const TextInput = styled(FormControl)`
  padding: 20px;
  border-bottom-left-radius: 20px !important;
  border-top-left-radius: 20px !important;
  text-transform: uppercase;
`;

const VoucherSearch = () => {
  const dispatch = useDispatch();
  const [query, setQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const [hasInitialLoaded, setHasInitialLoaded] = useState(false);
  const [voucherDoesNotExist, setVoucherDoesNotExist] = useState(false);
  const [queryDoesNotExist, setDoesNotExist] = useState("");
  const [voucher, setVoucher] = useState({});
  const processSearchQuery = (q) => {
    let newQuery = q.replace(/ /g, "");
    const oldQuery = query.replace(/ /g, "");
    if (
      (newQuery.endsWith("-") &&
        newQuery.length !== 4 &&
        newQuery.length !== 9) ||
      (newQuery.length === oldQuery.length && newQuery.length !== 12)
    ) {
      newQuery = newQuery.slice(0, -1);
    }

    if (!newQuery.endsWith("-") || oldQuery.length > newQuery.length) {
      newQuery = newQuery.replace(/-/g, "");
      if (newQuery.length > 7) {
        newQuery = `${newQuery.slice(0, 3)}-${newQuery.slice(
          3,
          7
        )}-${newQuery.slice(7)}`;
      } else if (newQuery.length > 3) {
        newQuery = `${newQuery.slice(0, 3)}-${newQuery.slice(3)}`;
      }
    }
    if (newQuery.length > 12) {
      newQuery = newQuery.slice(0, 12);
    }
    newQuery = newQuery.replace(/-/g, "  -  ");
    setQuery(newQuery);
  };

  const fetchVoucher = (searchedQuery) => {
    setLoading(true);
    dispatch(getVoucher(searchedQuery)).then(
      (v) => {
        setVoucherDoesNotExist(false);
        setDoesNotExist("");
        const newVoucher = {
          id: v.entitlement_id,
          productNumber: v.product_number,
          isValid: v.is_valid,
          status: v.status,
          lastActivity: v.last_activity
            ? moment(v.last_activity).format("L")
            : "-",
          numberOfUnlock: v.number_of_unlock,
          numberOfUnlockLeft: v.number_of_unlock_left,
          validFrom: moment(v.valid_from).format("L"),
          validTo: moment(v.valid_to).format("L"),
          usageLimitType: v.usage_limit_type,
          usageLimit: v.usage_limit,
          requiresOnline: v.requires_online,
          requiresLogin: v.requires_login,
          requiresFWVers: v.requires_fw_vers,
          purpose: v.purpose,
          createdBy: v.created_by,
          registrations: v.registrations,

          family: v.unit_family ? v.unit_family : "",
          packageName: v.package_name,
          voucherCode: v.voucher_code,
        };
        setVoucher(newVoucher);
        setLoading(false);
        setHasInitialLoaded(true);
      },
      (reason) => {
        setLoading(false);
        setVoucherDoesNotExist(true);
        setDoesNotExist(query);
        toastr.error(reason.error, "Error");
      }
    );
  };

  const search = () => {
    const searchedQuery = query.replace(/ /g, "");
    if (loading) {
      toastr.warning("Please wait! Currently searching.", "Warning");
    } else if (searchedQuery.length < 12) {
      toastr.error("Incomplete Voucher Code", "Error");
      setVoucherDoesNotExist(true);
      setDoesNotExist(query);
    } else {
      fetchVoucher(searchedQuery);
    }
  };

  const validateInvalidate = () => {
    const searchedQuery = query.replace(/ /g, "");
    const status = voucher.status === VoucherStatus.Invalid.displayName;

    dispatch(validateInvalidateVoucher(voucher.id, status)).then(
      (response) => {
        fetchVoucher(searchedQuery);
        toastr.info(response.message, "Update");
      },
      () => {
        toastr.error("Error validating/invalidating your voucher", "Error");
      }
    );
  };

  const submitButtonLabel =
    voucher.status === VoucherStatus.Invalid.displayName
      ? "Validate"
      : "Invalidate";

  return (
    <Grid fluid>
      <h2>Voucher Search</h2>
      <Row>
        <Col sm={12}>
          <Row style={{ marginTop: 40 }}>
            <Col sm={12} md={6} mdPush={3}>
              <FormGroup>
                <InputGroup>
                  <TextInput
                    type="text"
                    placeholder="Voucher Code"
                    value={query}
                    onChange={(e) => {
                      processSearchQuery(e.target.value);
                    }}
                    onKeyPress={(e) => {
                      if (e.key === "Enter") {
                        search();
                      }
                    }}
                  />
                  <InputGroup.Button>
                    <SearchButton
                      className="btn btn-primary pull-right"
                      onClick={() => search()}
                    >
                      <Glyphicon glyph="search" />
                    </SearchButton>
                  </InputGroup.Button>
                </InputGroup>
              </FormGroup>
            </Col>
          </Row>
          {loading && !hasInitialLoaded && <Loader message="Searching..." />}
          <Collapse in={!isEmpty(voucher)}>
            <div style={{ marginTop: 40 }}>
              <Panel>
                <PanelHeader>
                  <Row>
                    <Col sm={6}>
                      <PanelTitle bold title="Voucher Details" />
                    </Col>
                    <Col sm={6} style={{ textAlign: "end" }}>
                      {!isEmpty(voucher) && !voucherDoesNotExist && (
                        <Button
                          bsSize="small"
                          bsStyle="primary"
                          onClick={() => {
                            validateInvalidate();
                          }}
                        >
                          <Glyphicon glyph="cog" /> {submitButtonLabel}
                        </Button>
                      )}
                    </Col>
                  </Row>
                </PanelHeader>
                <Row>
                  <Col sm={12}>
                    <LoadingComponent isLoading={loading}>
                      <div className="panel-body" style={{ margin: "20px 0" }}>
                        {voucherDoesNotExist && queryDoesNotExist && (
                          <p>
                            Voucher ({queryDoesNotExist.toUpperCase()}) Does Not
                            Exist!
                          </p>
                        )}
                        {voucherDoesNotExist && !queryDoesNotExist && (
                          <p>Please input voucher code!</p>
                        )}
                        {!isEmpty(voucher) && !voucherDoesNotExist && (
                          <EntitlementDetail entitlement={voucher} />
                        )}
                      </div>
                    </LoadingComponent>
                  </Col>
                </Row>
              </Panel>
            </div>
          </Collapse>
        </Col>
      </Row>
    </Grid>
  );
};

export default VoucherSearch;
